
class AddToCart extends HTMLElement {


    constructor() {
        super(); 
        
        //Initiating the component

        // main button
        this.button = this.querySelector('button');

        // user controls
        this.variant_inputs = document.querySelectorAll('.variant-input input');
        this.prd_qty = document.querySelector('.product__quantity input');
        this.pro_qty_btns = document.querySelectorAll('.product__quantity button');

        // variants data
        this.variant_data_wrapper = this.querySelector('.variant-data');
        this.variant_data = this.querySelectorAll('.variant-data .variant');

        //Calls addListeners_userControls() method to attach event listeners to the various user inputs
        //In this case, it is all the variant radios, the quantity + and - buttons and the add-to-cart btn.
        this.addListeners_userControls();

    }


    addListeners_userControls() {


        //Setting up event listeners for user controls
        this.variant_inputs.forEach(input => {
            //When variant inputs change, it updates the variant ID and checks variant data
            input.addEventListener('change', () => {
                setTimeout(()=> {
                    this.update_VariantID(); 
                    this.check_variantData();
                })      
            });
        });

        this.prd_qty.addEventListener('change', ()=> {
            this.update_Qty(); 
            this.check_variantData(); 
        });

        this.pro_qty_btns.forEach(btn => {
            btn.addEventListener('click', ()=> {
                this.update_Qty();
                this.check_variantData(); 
            });
        });


        this.button.addEventListener('click', ()=> {

            this.clearNotifications();
    
            (async () => {
                let temp = await this.addItem(this.button.dataset.vid, this.button.dataset.qty);
                this.create_notification(temp);  
                await this.countCartItems();                    
            })();
                  
        });

    }


    clearNotifications() {
        let notifications = this.querySelectorAll('.add-to-cart-notification');
        if(notifications.length > 0) {
            notifications.forEach(ntf => {
                ntf.remove();
            });
        }
    }


    create_notification(temp) {

        console.log(temp)

        const notification = document.createElement('div');
        notification.classList.add('add-to-cart-notification');
        notification.style.color = '#fff';

        if (temp.status === 200) {
            notification.innerHTML = 'Το προϊόν προστέθηκε στο καλάθι!';
            notification.style.backgroundColor = '#8bbe8b';
        } else {
            notification.innerHTML = 'Παρουσιάστηκε πρόβλημα, προσπαθήστε ξανά αργότερα!';
            notification.style.backgroundColor = '#ba4444';
        }

        this.appendChild(notification);
        setTimeout(() => {
            notification.remove();
        }, 8000);
    }


    update_VariantID() {
        let urlParams = new URLSearchParams(window.location.search)
        let variantId = urlParams.get('variant');
        this.button.dataset.vid = variantId;
    }


    check_variantData() {

        const selectedVariant = Array.from(this.variant_data).find(variant => variant.dataset.variantId === this.button.dataset.vid);
        console.log(selectedVariant)

        if (selectedVariant) {

            const availability = selectedVariant.dataset.variantAvailability;
            const policy = selectedVariant.dataset.variantPolicy;
            const inventory = Number(selectedVariant.dataset.variantInventory);
            //console.log(inventory)

            if (availability === 'true') {            
                console.log('1 Variant is available');
                this.button.disabled = false;                
            } else {
                console.log('2 Variant is not available, and policy is set to deny')
                this.button.disabled = true;
            } 

            // Check MOQ vs inventory
            const moq = this.button.dataset.moq ? Number(this.button.dataset.moq) : 0;

            if(policy === 'deny') {

                // If MOQ is set and inventory is less than MOQ, always disable
                if (moq > 0 && inventory < moq) {
                    console.log('MOQ check failed: inventory', inventory, '< moq', moq);
                    this.button.disabled = true;
                    this.button.querySelector('[data-add-to-cart-text]').textContent = 'Μη διαθέσιμο (ανεπαρκές απόθεμα)';
                    return;
                }

                if (inventory > 0 && Number(this.prd_qty.value) > inventory) {
                    console.log('this.prd_qty.value', this.prd_qty.value, 'inventory', inventory)
                    console.log(Number(this.prd_qty.value) > inventory)
                    console.log('4 Quantity exceeds available inventory')
                    // Quantity exceeds available inventory
                    this.button.disabled = true;
                }

                if (inventory > 0 && Number(this.prd_qty.value) <= inventory) {
                    console.log('5 Quantity ok')
                    this.button.disabled = false;
                    this.button.querySelector('[data-add-to-cart-text]').textContent = this.button.querySelector('[data-add-to-cart-text]').dataset.defaultText;
                }
            }



        } else {
            console.log('Variant not found');
        }
    }


    update_Qty() {
        this.button.dataset.qty = this.prd_qty.value;
    }


    async addItem(id, qty) {

        const result = await fetch("/cart/add.json", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify({
            id: Number(id),
            quantity: Number(qty)
          })
        })
        
        return result;
    }


    async getCart() {
        const result = await fetch("/cart.json");
        console.log("result", result);
        if (result.status === 200) {
          return result.json();
        }
        throw new Error(`Failed to get request, Shopify returned ${result.status} ${result.statusText}`);
    }


    async countCartItems() {            
        const fetchCart = await this.getCart();         
        let itemsInCartCurrently = fetchCart.item_count;
        if(itemsInCartCurrently == 0) {
            //console.log('No items in cart, itemsInCartCurrently:', itemsInCartCurrently);
            document.querySelector('.cart-link__bubble').classList.remove('cart-link__bubble--visible')
        } else {               
            //console.log('itemsInCartCurrently:', itemsInCartCurrently);
            this.updateCartCount(itemsInCartCurrently);                                  
        } 
    
    }


    updateCartCount(itemsInCartCurrently) {
        document.querySelector('.cart-link__bubble-num').textContent = `${itemsInCartCurrently}`;
        document.querySelector('.cart-link__bubble').classList.add('cart-link__bubble--visible');
    }
    

}
customElements.define('add-to-cart', AddToCart); 